import { useParams } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";

const slugify = (s) => s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]+/g, "-").replace(/(^-|-$)/g, "").toLowerCase();

const Section = ({ section, index }) => (
  <section data-testid={`legal-section-${index}`} className={`${section.sub ? "mt-10" : "mt-14"} first:mt-0`}>
    {section.sub ? (
      <h3 className="font-head text-base md:text-lg tracking-tight text-black">{section.heading}</h3>
    ) : (
      <h2 className="h-section text-xl sm:text-2xl text-black">{section.heading}</h2>
    )}
    {section.subheading && (
      <p className="mt-6 font-head text-base md:text-lg tracking-tight text-black">{section.subheading}</p>
    )}
    {section.paragraphs.length > 0 && (
      <div className="mt-6 space-y-5">
        {section.paragraphs.map((p, i) => (
          <p key={i} className="text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{p}</p>
        ))}
      </div>
    )}
    {section.bullets && (
      <ul className="mt-5 space-y-2">
        {section.bullets.map((b, i) => (
          <li key={i} className="pl-5 text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{b}</li>
        ))}
      </ul>
    )}
    {section.after && (
      <div className="mt-5 space-y-5">
        {[].concat(section.after).map((p, i) => (
          <p key={i} className="text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{p}</p>
        ))}
      </div>
    )}
  </section>
);

export default function Legal() {
  const { slug } = useParams();
  const { content } = useLang();
  const { ui, footer, legal = {} } = content;
  const page = legal[slug];
  const title = page?.title || [...footer.company, ...footer.other].find((o) => slugify(o) === slug) || ui.legalTitle;

  return (
    <>
      <PageHero title={title} intro={page ? [] : [ui.legalText]} compact />
      {page && (
        <section className="bg-white" data-testid="legal-content">
          <div className="container-x py-16 md:py-24">
            <div className="max-w-3xl">
              {page.sections.map((s, i) => <Section key={i} section={s} index={i} />)}
            </div>
          </div>
        </section>
      )}
    </>
  );
}
